import { useSearchParams } from 'react-router-dom';
import { useCallback, useMemo } from 'react';

// Tink sends `error_reason`, `message` and `tracking_id` on failure; `error` and `error_display_message` are older names
const SELECTION_PARAMS = [
  'account_verification_report_id',
  'error_reason',
  'message',
  'tracking_id',
  'error',
  'error_display_message',
];

export function useSelectBankAccount() {
  const [searchParams, setSearchParams] = useSearchParams();

  const { id, errorCode, errorMessage } = useMemo(
    () => ({
      id: searchParams.get('account_verification_report_id'),
      errorCode: searchParams.get('error_reason') ?? searchParams.get('error'),
      errorMessage: searchParams.get('message') ?? searchParams.get('error_display_message'),
    }),
    [searchParams],
  );

  /** Drops the bank's result from the URL, e.g. once the account is saved, so a reload doesn't reuse it */
  const clear = useCallback(
    () =>
      setSearchParams(
        (params) => {
          SELECTION_PARAMS.forEach((key) => params.delete(key));
          return params;
        },
        { replace: true },
      ),
    [setSearchParams],
  );

  return { id, errorCode, errorMessage, clear };
}
